import httpApi from '../api/httpApi';
import {
    ForgotPasswordRequest,
    ResetPasswordParams,
} from '../../models/Authentication/ForgotPassword';

const useForgotPassword = () => {
    const RESET_PASSWORD_URL = '/api/v1/password-reset';
    const FORGOT_PASSWORD_URL = '/api/v1/forgot-password';

    const sendResetPassword = (data) => {
        return httpApi
            .post<ResetPasswordParams>(RESET_PASSWORD_URL, data)
            .then((resp) => {
                return resp.getData();
            });
    };

    const sendForgotPassword = (data) => {
        return httpApi
            .post<ForgotPasswordRequest>(FORGOT_PASSWORD_URL, data)
            .then((resp) => {
                return resp.getData();
            });
    };

    return {
        sendResetPassword,
        sendForgotPassword,
    };
};

export default useForgotPassword;
